import axios from 'axios'
import apiConfig from '@/api/config'

// 创建axios实例
const service = axios.create({
  baseURL: apiConfig.getBaseUrl(),
  timeout: 120000  // 增加到2分钟，AI评分需要更长时间
})

// 开发环境日志函数
const devLog = (level, message, data) => {
  if (process.env.NODE_ENV === 'development') {
    console[level](message, data)
  }
}

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 从localStorage获取token
    const token = localStorage.getItem('adminToken')
    if (token) {
      // 确保添加 'Bearer ' 前缀
      config.headers['Authorization'] = `Bearer ${token}`
    }

    // 从localStorage获取访问sessionId
    const sessionId = localStorage.getItem('accessSessionId')
    if (sessionId) {
      config.headers['X-Session-ID'] = sessionId
    }

    // 确保URL不会出现双斜杠
    config.url = config.url.replace(/^\/+/, '')
    
    // 在开发环境中，如果URL不是以api开头，则添加api前缀
    if (!config.url.startsWith('api/')) {
      config.url = `api/${config.url}`
    }

    // 如果是表单数据，确保正确处理
    if (config.headers['Content-Type'] === 'application/x-www-form-urlencoded' && 
        config.data instanceof URLSearchParams) {
      // URLSearchParams对象会被自动处理，无需额外处理
    }

    devLog('log', '发送请求:', {
      baseURL: config.baseURL,
      url: config.url,
      fullURL: `${config.baseURL}/${config.url}`,
      method: config.method,
      headers: config.headers,
      params: config.params,
      data: config.data
    });
    return config;
  },
  error => {
    console.error('请求配置错误:', error);
    return Promise.reject(error);
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    devLog('log', '收到响应:', {
      status: response.status,
      data: response.data,
      headers: response.headers
    });
    
    // 如果响应数据包含错误信息，抛出错误
    if (response.data && response.data.error) {
      return Promise.reject(new Error(response.data.error));
    }
    
    return response.data;
  },
  error => {
    devLog('error', '请求失败:', {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status
    });
      
    // 处理401未授权错误
    if (error.response?.status === 401) {
      // 清除本地存储的管理员token
        localStorage.removeItem('adminToken');
        localStorage.removeItem('adminUsername');

      // 可以在这里添加重定向到登录页的逻辑
      console.warn('管理员token已过期，请重新登录');
    }

    // 处理403访问被拒绝错误
    if (error.response?.status === 403) {
      // 清除访问session
      localStorage.removeItem('accessSessionId');
      localStorage.removeItem('accessCategory');
      console.warn('访问权限已过期');
    }

    return Promise.reject(error);
  }
)

export default service